<template>
    <div class="t-box">
        <!-- <div style="position: relative;">
            <el-input :placeholder="placeholder || '请选择附件'" suffix-icon="el-icon-upload">
            </el-input>
            <input type="file" :multiple="multiple" :accept="accept" class="file-box" @change="uploadFileBox">
        </div> -->
        <el-upload :disabled="disabled" class="upload-demo" :accept="accept" :multiple="multiple" style="width: 100%;height: 8rem;" :drag="true" action="#" :auto-upload="false"
            :show-file-list="false" :on-change="uploadFileBox">
            <div class="upload-tip">
                <img class="img-icon" style="width: 3rem;height: auto;" src="../../assets/image/magSys/upload.png" alt="">
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" v-if="accept" slot="tip">{{ `(仅支持文件格式：${accept})` }}</div>
            </div>
        </el-upload>
        <div class="progress-box" v-if="fileArr.length>0">
            <div v-for="(item, index) in fileArr"  class="progress-item" :key="index">
                <div class="show-box" v-if="item.status == 'pending'" style="margin-top: 10px;">
                    <el-progress :percentage="currentPercent(item)"></el-progress>
                    <i class="iconfont el-icon-close" @click="closeUpload(item,index)"></i>
                    <i :class="['icon', 'iconfont', !item.isStop ? 'icon-weibiaoti519' : 'icon-weibiaoti518']"
                        @click="startStop(item)"></i>
                </div>
                <div class="file-title-box" v-if="item.status == 'success'">
                    <i class="el-icon-paperclip"></i>
                    <el-tooltip class="item" effect="dark" :content="item.fileName" placement="top-start">
                        <div>{{ item.fileName }}</div>
                    </el-tooltip>
                    <i class="el-icon-close" :class="{'disabled-btn':disabled}" @click="delFile(index)"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { chunkInit, chunkUpload } from '@/api/file/commonFile';
import { uploadFile } from '@/assets/js/oss';
import SparkMD5 from 'spark-md5';
export default {
    props: ['placeholder', 'multiple', 'accept', 'isPreview','disabled'],
    data() {
        return {
            fileArr: [],
        }
    },
    methods: {
        /**清空选择的文件 */
        clearValue() {
            var input = document.querySelector('.file-box');
            if (input) {
                input.value = '';
            }
        },
        currentPercent(item) {
            return Math.round(item.currentChunk / item.chunkCount * 100);
        },
        closeUpload(item,index){
            item.isStop=true;
            this.fileArr.splice(index,1);
        },
        /**删除文件 */
        delFile(index) {
            if(this.disabled)return;
            this.fileArr.splice(index, 1);
            var dom = document.querySelector('.file-box');
            if (dom) dom.value = '';
            this.$emit('del_file', this.getId());
        },
        /**开始暂停 */
        async startStop(item) {
            if(this.disabled)return;
            item.isStop = !item.isStop;
            if (!item.isStop) {
                this.loadingUpload(item, item.currentChunk + 1);
            }
        },
        async uploadFileBox(e) {
            if(this.disabled)return;
            if(!this.multiple&&this.fileArr.length>0){
                this.delFile(0);
            }
            var file=e.raw;
            if (file.size > 5 * 1024 * 1024 * 1024) {
                    this.$msg({
                                showClose: true,
                                message: "上传文件大小不得超过5G",
                                type: "error",
                            });
                    return;
                }
                let obj = new Object();
                obj.chunkSize = 1024 * 1024 * 5;
                obj.currentChunk = 0;
                obj.md5 = '';
                obj.initFileData = new Object();
                obj.file = file;
                obj.fileName = '';
                obj.isStop = false;
                obj.status = '';
                obj.chunkCount = Math.ceil(file.size / obj.chunkSize)
                this.fileArr.push(obj);
                if (obj.file.size < 10 * 1024 * 1024) {
                    uploadFile(obj.file, this.isPreview === false ? false : true).then((res) => {
                        if (res) {
                            obj.status = 'success';
                            this.$msg({
                                showClose: true,
                                message: "上传成功",
                                type: "success",
                            });
                            obj.id = res.id;
                            obj.fileName = res.fileName;
                            obj.response = res;
                            this.$emit('upload', this.getId());
                        }
                    }).catch(()=>{
                        this.fileArr.pop();
                    });
                    return;
                }
                obj.status = 'pending';
                await this.fileMd5Sum(obj);
                await this.initUpload(obj);
                if (obj.initFileData.secondUpload) {
                    obj.fileName = obj.initFileData.fileName;
                    obj.id = obj.initFileData.id;
                    obj.status = 'success';
                    this.$msg({
                        showClose: true,
                        message: "上传成功",
                        type: "success",
                    });
                    this.$emit('upload', this.getId());
                    return;
                }
                this.loadingUpload(obj);
        },
        /**处理分片 */
        uploadChunk(item, index) {
            // 计算分片的起始和结束字节
            let start = (index - 1) * item.chunkSize;
            let end = Math.min(item.file.size, start + item.chunkSize);
            // 将分片读取为Blob
            let chunk = item.file.slice(start, end);
            // 创建FormData并附加分片
            let formData = new FormData();
            formData.append('chunkNumber', index);
            formData.append('chunkSize', end - start);
            formData.append('file', chunk);
            formData.append('fileExt', item.initFileData.fileExt);
            formData.append('fileKey', item.initFileData.fileKey);
            formData.append('fileName', item.file.name);
            formData.append('fileSearch', item.initFileData.fileSearch);
            formData.append('fileSize', item.file.size);
            formData.append('md5', item.initFileData.md5);
            formData.append('secondUpload', item.initFileData.secondUpload);
            formData.append('totalChunks', item.chunkCount);
            formData.append('uploadId', item.initFileData.uploadId);
            return formData
        },
        loadingUpload(item, i = item.currentChunk+1) {
            let params = this.uploadChunk(item, i);
            chunkUpload(params).then(res => {
                item.currentChunk = i;
                if (item.isStop) return;
                i++;
                if (item.currentChunk >= item.chunkCount) {
                    this.$msg({
                        showClose: true,
                        message: "上传成功",
                        type: "success",
                    });
                    item.fileName = res.data.fileName;
                    item.id = res.data.id;
                    item.status = 'success';
                    item.response = res.data;
                    this.$emit('upload', this.getId());
                    return;
                }
                this.loadingUpload(item, i);
            }).catch(()=>{
                var index1=this.fileArr.findIndex(e=>e.md5==item.md5);
                if(index1!=-1){
                    this.fileArr.splice(index1,1);
                }
            })
        },
        /**上传初始化 */
        initUpload(obj) {
            return new Promise((resolve) => {
                var params = {
                    "fileName": obj.file.name,
                    "fileSearch": true,
                    "fileSize": obj.file.size,
                    "md5": obj.md5
                };
                chunkInit(params).then(res => {
                    if (res.code == 200) {
                        obj.initFileData = res.data;
                        obj.response = res.data;
                        if(res.data.chunkDataList&&res.data.chunkDataList.length>0){
                            obj.currentChunk=res.data.chunkDataList.length;
                        }
                        resolve(res);
                    }
                }).catch(()=>{
                        this.fileArr.pop();
                    });
            })
        },
        /**获取所有上传成功的id */
        getId() {
            var ids = [];
            if (this.multiple) {
                this.fileArr.forEach((item) => {
                    if (item.id) {
                        ids.push(item.response)
                    }
                })
            } else {
                if (this.fileArr.length > 0) {   
                    ids = [this.fileArr[0].response];
                }
            }
            return ids;
        },
        async calculateFileMD5(file, chunkSize = 2 * 1024 * 1024) {
        return new Promise((resolve, reject) => {
            const spark = new SparkMD5.ArrayBuffer();
            const fileReader = new FileReader();
            const chunks = Math.ceil(file.size / chunkSize);
            let currentChunk = 0;

            fileReader.onload = (e) => {
            spark.append(e.target.result); // 添加当前 chunk 数据
            currentChunk++;

            if (currentChunk < chunks) {
                loadNextChunk(); // 继续读取下一块
            } else {
                resolve(spark.end()); // 所有 chunks 读取完毕，计算最终 MD5
            }
            };

            fileReader.onerror = () => {
            reject(new Error("文件读取失败"));
            };

            function loadNextChunk() {
            const start = currentChunk * chunkSize;
            const end = Math.min(start + chunkSize, file.size);
            const chunk = file.slice(start, end); // 切割文件块
            fileReader.readAsArrayBuffer(chunk); // 读取当前块
            }

            loadNextChunk(); // 开始读取第一个块
        });
        },
        /**计算完整文件 MD5 */
        async fileMd5Sum(item) {
            const md5 = await this.calculateFileMD5(item.file, 5 * 1024 * 1024);
            item.md5 = md5;
            return md5;
        }
    },
}
</script>

<style lang="less" scoped>
.file-box {
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: aqua;
    top: 0;
    left: 0;
    z-index: 999;
    opacity: 0;
}

.show-box {
    position: relative;
    display: flex;
    align-items: center;
    .el-icon-close{
        color: #E84344;
        font-weight: 700;
        background-color: #FCE4E6;
        width: 2.5rem;
        height: 2.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        margin-right: 1rem;
        font-size: 14px;
        cursor: pointer;
    }
    &> :nth-child(3){
        color: #9C9FB0;
        background-color: #E2E6EF;
        width: 2.5rem;
        height: 2.5rem;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
}

.file-title-box {
    display: flex;
    align-items: center;

    &> :nth-child(1) {
        margin-right: 10px;
    }

    &> :nth-child(2) {
        width: calc(100% - 100px);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: left;
    }

    &> :nth-child(3) {
        width: 15px;
        height: 15px;
        color: #ffffff;
        font-size: 12px;
        text-align: center;
        line-height: 15px;
        background-color: var(--red);
        border-radius: 50%;
        margin-left: 20px;
        cursor: pointer;
    }
}

.progress-box {
    margin-top: 0.8rem;
    min-height: 5rem;
    background: #f7f8fb;
    border: 1px dashed #e8ecef;
    width: 100%;
    padding: 1.5rem;
    &> :nth-child(n){
        margin-top: 1rem;
    }
    &> :nth-child(1){
        margin-top: 0;
    }
}

/deep/.el-progress {
    margin-left: 18px !important;
    width: calc(100% - 80px);
}
/deep/.el-upload{
    width: 100%;
    height: 100%;
}
/deep/.el-upload-dragger{
    height: 100%;
    width: 100%;
}
.upload-tip{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    i{
        font-size: 3rem;
        color: var(--blue);
    }
    &> :nth-child(3){
        color: #8590B3;
    }
}
/deep/.el-upload__tip{
    margin-top: 0;
}
</style>
